import { render, staticRenderFns } from "./TemplateSelect.vue?vue&type=template&id=db940f82&scoped=true&"
import script from "./TemplateSelect.vue?vue&type=script&lang=ts&"
export * from "./TemplateSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSelect.vue?vue&type=style&index=0&id=db940f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db940f82",
  null
  
)

export default component.exports